// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__AS6vE","col":"styles_col__Wp4JO"};